<div class="flex-direction-column page-redesign">
  <div class="lembrete-cabecalho flex-direction-row justify-between align-center wrap gap-15">
    <app-titulo-rotina
      class="lembrete-titulo"
      titulo="Lembretes"
      subtitulo="Gerencie os lembretes criados para você e seus contatos."
      [mostrarBotaoMenu]="true"
      (aoVoltar)="voltar()"
      (aoAbrirMenu)="abrirMenuMobile()">
    </app-titulo-rotina>

    <div class="lembrete-acoes">
      <app-search placeholder="Pesquisar lembrete, contato..." (valorChange)="filtrarBusca($event)"></app-search>
      <app-botao class="lembrete-botao-novo" label="Novo Lembrete" (aoClicar)="abrirModal()"></app-botao>
    </div>
  </div>

  <app-filtros-tab
    class="lembrete-filtros"
    [abas]="abasFiltro"
    [abaAtiva]="abaAtiva"
    [carregando]="carregandoContagem"
    (aoSelecionar)="selecionarAba($any($event))">
  </app-filtros-tab>

  @if (carregando) {
    <app-tabela class="lembrete-vista-desktop" [carregando]="true" [colunasSkeleton]="6" [linhasSkeleton]="5"></app-tabela>

    <div class="lembrete-vista-mobile lembrete-cards-mobile flex-direction-column">
      @for (i of [1, 2, 3]; track i) {
        <div class="lembrete-card-mobile-skeleton skeleton"></div>
      }
    </div>
  } @else if (lembretes.length > 0) {
    <app-tabela class="lembrete-vista-desktop">
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="gutterInicio">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let elemento"></mat-cell>
        </ng-container>

        <ng-container matColumnDef="acao">
          <mat-header-cell *matHeaderCellDef>Ações</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <div class="flex-direction-row gap-5">
              <app-tabela-acao icone="./assets/icones/redesign/table/icon-view-table.svg" titulo="Visualizar"
                (aoClicar)="abrirModalVisualizar(elemento)"></app-tabela-acao>
              @if (elemento.status !== StatusLembreteEnum.ERRO && elemento.status !== StatusLembreteEnum.CONCLUIDO) {
                @if (elemento.podeEditar) {
                  <app-tabela-acao icone="./assets/icones/redesign/table/icon-edit-table.svg" titulo="Editar"
                    (aoClicar)="abrirModal(elemento)"></app-tabela-acao>
                }
              }
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="lembrete">
          <mat-header-cell *matHeaderCellDef>Lembrete</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <div class="lembrete-tabela-lembrete">
              <span class="lembrete-tabela-sino-fundo">
                <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" class="lembrete-tabela-sino" />
              </span>
              <div class="lembrete-tabela-textos lembrete-tabela-textos-crescer">
                <span [matTooltip]="elemento.titulo" class="lembrete-tabela-texto" style="font-weight: 600">{{ elemento.titulo }}</span>
                @if (elemento.anotacao) {
                  <span class="linha-secundaria lembrete-tabela-texto" [matTooltip]="elemento.anotacao">{{ elemento.anotacao }}</span>
                }
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="contato">
          <mat-header-cell *matHeaderCellDef>Contato</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <div class="lembrete-tabela-contato">
              <div class="lembrete-tabela-textos">
                <span class="lembrete-tabela-texto" [matTooltip]="elemento.contato.nome">{{ elemento.contato.nome | titlecase }}</span>
                <span class="linha-secundaria lembrete-tabela-texto">{{ elemento.contatoNumero | celularMask }}</span>
              </div>
              <button type="button" class="lembrete-ir-contato" matTooltip="Abrir em Contatos" aria-label="Abrir contato na tela de Contatos"
                      [disabled]="!elemento.contatoNumero" (click)="irParaContato(elemento, $event)">
                <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg" alt="" />
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipo">
          <mat-header-cell *matHeaderCellDef>Tipo</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <div class="lembrete-tabela-tipo">
              <span class="badge-tipo" [class.badge-tipo-mim]="elemento.tipo === TipoLembreteEnum.PARA_MIM">{{ tipoLabel[elemento.tipo] }}</span>
              @if (elemento.tipo === TipoLembreteEnum.PARA_CLIENTE && elemento.template?.id) {
                <span class="lembrete-tabela-template" [matTooltip]="elemento.template.id + ' - ' + elemento.template.nome">
                  <img src="./assets/icones/redesign/modulos/chat/components-message/template-icon-message-gray.svg" alt="" />
                  <span class="lembrete-tabela-texto">{{ elemento.template.id }} - {{ elemento.template.nome }}</span>
                </span>
              }
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="dataHora">
          <mat-header-cell *matHeaderCellDef>Data e hora</mat-header-cell>
          <mat-cell *matCellDef="let elemento">{{ elemento.dataHora | date: 'dd/MM/yyyy · HH:mm' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="criadoPor">
          <mat-header-cell *matHeaderCellDef>Criado por</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            @if (elemento.operador?.id) {
              <app-avatar-pessoa [pessoa]="elemento.operador" [tamanho]="24" [matTooltip]="elemento.operador?.nome ?? ''"></app-avatar-pessoa>
            } @else {
              -
            }
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <span class="badge-status" [class.badge-status-pendente]="elemento.status === StatusLembreteEnum.PENDENTE"
                  [class.badge-status-concluido]="elemento.status === StatusLembreteEnum.CONCLUIDO"
                  [class.badge-status-rodando]="elemento.status === StatusLembreteEnum.RODANDO"
                  [class.badge-status-erro]="elemento.status === StatusLembreteEnum.ERRO"
                  [matTooltip]="elemento.status === StatusLembreteEnum.ERRO ? elemento.mensagemErro : ''">
              <span class="bolinha-status" [class.status-pendente]="elemento.status === StatusLembreteEnum.PENDENTE"
                    [class.status-concluido]="elemento.status === StatusLembreteEnum.CONCLUIDO"
                    [class.status-rodando]="elemento.status === StatusLembreteEnum.RODANDO"
                    [class.status-erro]="elemento.status === StatusLembreteEnum.ERRO"></span>
              {{ statusLabel[elemento.status] }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="gutterFim">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let elemento"></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </app-tabela>

    <app-paginador
      class="lembrete-vista-desktop"
      [length]="length"
      [pageSize]="limit"
      [pageIndex]="page"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="handlePageEvent($event)">
    </app-paginador>

    <div class="lembrete-vista-mobile lembrete-cards-mobile flex-direction-column" (scroll)="onScrollListaMobile($event)">
      @for (elemento of lembretes; track elemento.id) {
        <div class="lembrete-card-mobile" (click)="abrirModalVisualizar(elemento)">
          <div class="lembrete-card-mobile-topo">
            <span class="lembrete-tabela-sino-fundo lembrete-card-mobile-sino-fundo">
              <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" class="lembrete-card-mobile-sino" />
            </span>
            <div class="flex-direction-column gap-5 lembrete-card-mobile-info">
              <span class="lembrete-card-mobile-titulo" [matTooltip]="elemento.titulo">{{ elemento.titulo }}</span>
              @if (elemento.anotacao) {
                <span class="lembrete-card-mobile-anotacao">{{ elemento.anotacao }}</span>
              }
              <span class="lembrete-card-mobile-contato">{{ elemento.contato.nome | titlecase }} · {{ elemento.contatoNumero | celularMask }}</span>
            </div>
            <div class="lembrete-card-mobile-lateral">
              <span class="badge-status lembrete-card-mobile-status" [class.badge-status-pendente]="elemento.status === StatusLembreteEnum.PENDENTE"
                    [class.badge-status-concluido]="elemento.status === StatusLembreteEnum.CONCLUIDO"
                    [class.badge-status-rodando]="elemento.status === StatusLembreteEnum.RODANDO"
                    [class.badge-status-erro]="elemento.status === StatusLembreteEnum.ERRO"
                    [matTooltip]="elemento.status === StatusLembreteEnum.ERRO ? elemento.mensagemErro : ''">
                <span class="bolinha-status" [class.status-pendente]="elemento.status === StatusLembreteEnum.PENDENTE"
                      [class.status-concluido]="elemento.status === StatusLembreteEnum.CONCLUIDO"
                      [class.status-rodando]="elemento.status === StatusLembreteEnum.RODANDO"
                      [class.status-erro]="elemento.status === StatusLembreteEnum.ERRO"></span>
                {{ statusLabel[elemento.status] }}
              </span>
              <div class="lembrete-card-mobile-lateral-acoes">
                @if (elemento.operador?.id) {
                  <app-avatar-pessoa [pessoa]="elemento.operador" [tamanho]="26" [matTooltip]="'Criado por ' + (elemento.operador?.nome ?? '')"></app-avatar-pessoa>
                }
                <button type="button" class="lembrete-ir-contato" aria-label="Abrir contato na tela de Contatos"
                        [disabled]="!elemento.contatoNumero" (click)="irParaContato(elemento, $event)">
                  <img src="./assets/icones/redesign/modulos/chat/components-message/go-to-chat-primary.svg" alt="" />
                </button>
              </div>
            </div>
          </div>

          <div class="lembrete-card-mobile-divisor"></div>

          <div class="lembrete-card-mobile-rodape">
            <span class="badge-tipo" [class.badge-tipo-mim]="elemento.tipo === TipoLembreteEnum.PARA_MIM">{{ tipoLabel[elemento.tipo] }}</span>
            <span class="lembrete-card-mobile-data">
              <img src="./assets/icones/redesign/inputs/input-time-clock.svg" alt="" class="lembrete-card-mobile-data-icone" />
              {{ elemento.dataHora | date: 'dd/MM/yyyy · HH:mm' }}
            </span>

            <div class="lembrete-card-mobile-acoes" (click)="$event.stopPropagation()">
              @if (elemento.status !== StatusLembreteEnum.ERRO) {
                @if (elemento.podeEditar) {
                  <button type="button" class="lembrete-card-mobile-btn-icone" title="Editar" (click)="abrirModal(elemento)">
                    <img src="./assets/icones/redesign/table/icon-edit-table.svg" alt="" />
                  </button>
                }
              }
            </div>
          </div>
        </div>
      }

      @if (carregandoMais) {
        <div class="lembrete-card-mobile-skeleton skeleton"></div>
      }
    </div>

  } @else {
    <div class="flex center-center height-100">
      <img class="lembrete-imagem-vazio" src="./assets/imagem-mulher-nao-eh-bug.png" alt="Nenhum lembrete encontrado">
    </div>
  }

  @if (!carregando) {
    <button type="button" class="lembrete-fab" title="Novo Lembrete" (click)="abrirModal()">
      <img src="./assets/icones/redesign/button/icon-add-button.svg" alt="" />
    </button>
  }
</div>
